import { useSelector } from "@redux";
import { Card, Col, Row } from "antd"
import FormItem from "components/form/FormItem";
import FormSelect from "components/form/FormSelect";
import { useTranslation } from "react-i18next"
import { DynamicObjectType } from "types/commons";

export default function GeneralInformation() {
   const { t } = useTranslation();
   const locationsCurr = useSelector((state) => state.locations.currentData) as DynamicObjectType;

   return (
      <Card title={t('mores.locations.generalInformation')}>
         <Row gutter={[16, 16]}>
            <Col md={12}>
               <FormItem
                  name="name"
                  label={t('mores.locations.name.label')}
                  required
                  placeholder={t('mores.locations.name.placeholder')}
               />
            </Col>
            <Col md={12}>
               <FormItem
                  name="code"
                  label={t('mores.locations.locationID.label')}
                  required
                  placeholder={t('mores.locations.locationID.placeholder')}
               />
            </Col>
            <Col md={12}>
               <FormItem
                  name="email"
                  label={t('mores.locations.email.label')}
                  placeholder={t('mores.locations.email.placeholder')}
               />
            </Col>
            <Col md={12}>
               <FormItem
                  name="phoneNumber"
                  label={t('mores.locations.phoneNumber.label')}
                  placeholder={t('mores.locations.phoneNumber.placeholder')}
               />
            </Col>
            <Col md={24}>
               <FormSelect
                  reference={{
                     labelProp: 'name',
                     model: 'chain-stores',
                     searchKey: 'name',
                     childFormKey: 'id',
                     allowClear: true,
                     dependency: locationsCurr?.id,
                  }}
                  label={t('mores.locations.brand.label')}
                  name="chainStoreId"
                  placeholder={t('mores.locations.brand.placeholder')}
                  required
               />
            </Col>
         </Row>
      </Card>
   )
}